import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';
import MeetingList from './mom/MeetingList';
import ActionItemsTable from './mom/ActionItemsTable';
import MOMSettings from './mom/MOMSettings';

const CompanyMOMTracker: React.FC = () => {
  const { userProfile } = useAuth();
  const companyId = userProfile?.company_id;
  const [activeTab, setActiveTab] = useState<string>('meetings');
  const [settings, setSettings] = useState<any[]>([]);

  useEffect(() => {
    if (companyId) {
      fetchSettings();
    }
  }, [companyId]);

  const fetchSettings = async () => {
    if (!companyId) return;
    const { data, error } = await supabase
      .from('mom_settings')
      .select('*')
      .eq('company_id', companyId);
    
    if (!error && data) {
      setSettings(data);
    }
  };

  const renderTab = () => {
    if (activeTab === 'meetings') {
      return <MeetingList companyId={companyId} settings={settings} />;
    } else if (activeTab === 'master_dump') {
      return <ActionItemsTable companyId={companyId} viewType="master" settings={settings} />;
    } else if (activeTab === 'settings') {
      return <MOMSettings companyId={companyId} settings={settings} refreshSettings={fetchSettings} />;
    } else if (activeTab.startsWith('tracker_')) {
      const member = activeTab.replace('tracker_', '');
      return <ActionItemsTable companyId={companyId} viewType="personal" settings={settings} selectedTeamMember={member} />;
    }
    return null;
  };

  return (
    <div className="mom-tracker-root" style={{ padding: '2rem', maxWidth: '1400px', margin: '0 auto' }}>
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--text)' }}>MOM Tracker</h1>
        <p style={{ color: 'var(--text-secondary)' }}>Manage your meetings, action items, and tracker settings.</p>
      </div>

      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '2rem', borderBottom: '2px solid var(--border)' }}>
        <button
          onClick={() => setActiveTab('meetings')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: 'transparent',
            borderBottom: activeTab === 'meetings' ? '2px solid var(--primary)' : '2px solid transparent',
            color: activeTab === 'meetings' ? 'var(--primary)' : 'var(--text-secondary)',
            fontWeight: activeTab === 'meetings' ? '600' : '400',
            cursor: 'pointer',
            marginBottom: '-2px'
          }}
        >
          Meetings
        </button>
        <button
          onClick={() => setActiveTab('master_dump')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: 'transparent',
            borderBottom: activeTab === 'master_dump' ? '2px solid var(--primary)' : '2px solid transparent',
            color: activeTab === 'master_dump' ? 'var(--primary)' : 'var(--text-secondary)',
            fontWeight: activeTab === 'master_dump' ? '600' : '400',
            cursor: 'pointer',
            marginBottom: '-2px'
          }}
        >
          Master Dump
        </button>
        {settings.filter(s => s.category === 'Team').map(member => (
          <button
            key={member.id}
            onClick={() => setActiveTab(`tracker_${member.value}`)}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              background: 'transparent',
              borderBottom: activeTab === `tracker_${member.value}` ? '2px solid var(--primary)' : '2px solid transparent',
              color: activeTab === `tracker_${member.value}` ? 'var(--primary)' : 'var(--text-secondary)',
              fontWeight: activeTab === `tracker_${member.value}` ? '600' : '400',
              cursor: 'pointer',
              marginBottom: '-2px'
            }}
          >
            {member.value}
          </button>
        ))}
        <button
          onClick={() => setActiveTab('settings')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: 'transparent',
            borderBottom: activeTab === 'settings' ? '2px solid var(--primary)' : '2px solid transparent',
            color: activeTab === 'settings' ? 'var(--primary)' : 'var(--text-secondary)',
            fontWeight: activeTab === 'settings' ? '600' : '400',
            cursor: 'pointer',
            marginBottom: '-2px',
            marginLeft: 'auto'
          }}
        >
          ⚙️ Settings
        </button>
      </div>

      <div className="card" style={{ padding: '2rem' }}>
        {renderTab()}
      </div>
    </div>
  );
};

export default CompanyMOMTracker;
